import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MessageTranslateService } from '../../../../shared/services/message.service';
import { LocationService } from '../../services/location.service';
import * as statActions from './location-stat.actions';
import { catchError, map, of, switchMap } from 'rxjs';
import { ErrorUtil } from '../../../../shared/utils/error.util';

export class LocationStatisticsEffects {
  actions$: Actions = inject(Actions);
  messageService = inject(MessageTranslateService);
  locationService = inject(LocationService);

  loadLocationStatistics$ = createEffect(() =>
    this.actions$.pipe(
      ofType(statActions.loadLocationStatistics),
      switchMap((requestData) => {
        return this.locationService
          .getLocationStatistics(
            requestData.locationId,
            requestData.dateFrom,
            requestData.dateTo
          )
          .pipe(
            map((res) =>
              statActions.loadLocationStatisticsSuccess({
                locationStatistics: res.value!,
              })
            ),
            catchError((err) =>
              of(
                statActions.loadLocationStatisticsFailure({
                  error: ErrorUtil.convertToErrorModel(err),
                })
              )
            )
          );
      })
    )
  );
}
